import { render, staticRenderFns } from "./pendingList.vue?vue&type=template&id=0ff7630f&scoped=true&"
import script from "./pendingList.vue?vue&type=script&lang=js&"
export * from "./pendingList.vue?vue&type=script&lang=js&"
import style0 from "./pendingList.vue?vue&type=style&index=0&id=0ff7630f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff7630f",
  null
  
)

export default component.exports